import { PaymentMethod } from '../../interfaces';
import { PAYMENT_METHOD_ID } from '../payment-method-id';

export const BANCOMAT_PAY: PaymentMethod = {
    id: PAYMENT_METHOD_ID.BancomatPay,
    name: 'bancomatpay',
    displayName: 'BancomatPay'
};
